import './FeaturesSection.css';
import { BOOK_DEMO_URL } from '../../constants/urls';
import { BrandLogo } from '../BrandLogo';

function FeatureBadgeIcon({ type }: { type: string }) {
  switch (type) {
    case 'personalized':
      return (
        <svg viewBox="0 0 20 20" aria-hidden="true">
          <circle cx="7" cy="7" r="3" fill="currentColor" />
          <path
            d="M3 17c0-3 2-5 4-5h0M13 11h4v4M15 9v6"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'integrations':
      return (
        <svg viewBox="0 0 20 20" aria-hidden="true">
          <rect
            x="3"
            y="6"
            width="14"
            height="10"
            rx="1.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path d="M3 9h14" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M7 6V4a1 1 0 011-1h4a1 1 0 011 1v2"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
        </svg>
      );
    case 'ai':
      return (
        <svg viewBox="0 0 20 20" aria-hidden="true">
          <path
            d="M10 2l1.2 4h4.3l-3.5 2.5 1.3 4.5L10 11.5 6.7 13l1.3-4.5L4.5 6h4.3L10 2z"
            fill="currentColor"
          />
        </svg>
      );
    case 'followups':
      return (
        <svg viewBox="0 0 20 20" aria-hidden="true">
          <circle cx="8" cy="7" r="3" fill="currentColor" />
          <path
            d="M3 17c0-2.5 2-4.5 5-4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
          <circle
            cx="15"
            cy="13"
            r="4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M15 11v2l1.5 1"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'reactivation':
      return (
        <svg viewBox="0 0 20 20" aria-hidden="true">
          <path
            d="M10 3l1.5 4.5H16l-3.7 2.7 1.4 4.8L10 12.8 6.3 15l1.4-4.8L4 7.5h4.5L10 3z"
            fill="currentColor"
          />
          <path
            d="M14 14a5 5 0 11-2-4"
            stroke="currentColor"
            strokeWidth="1.2"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      );
    default:
      return null;
  }
}

function JobberLogo() {
  return (
    <svg viewBox="0 0 28 28" aria-hidden="true" className="partner-logo">
      <rect x="4" y="16" width="4" height="8" rx="1" fill="#00b2e3" />
      <rect x="12" y="10" width="4" height="14" rx="1" fill="#00b2e3" />
      <rect x="20" y="4" width="4" height="20" rx="1" fill="#00b2e3" />
    </svg>
  );
}

function ZapierLogo() {
  return (
    <svg viewBox="0 0 28 28" aria-hidden="true" className="partner-logo">
      <path
        fill="#ff4a00"
        d="M14 4l1.6 4.8h5.1l-4.1 3 1.6 4.8-4-2.9-4 2.9 1.6-4.8-4.1-3h5.1L14 4zm0 10.5l.8 2.4 2.5-1.8-.9 2.8h3l-2.5 1.8.9 2.8-2.5-1.8-2.5 1.8.9-2.8-2.5-1.8h3l-.9-2.8 2.5 1.8.8-2.4z"
      />
    </svg>
  );
}

function MondayLogo() {
  return (
    <svg viewBox="0 0 28 28" aria-hidden="true" className="partner-logo">
      <circle cx="8" cy="8" r="2.5" fill="#00c875" />
      <circle cx="20" cy="8" r="2.5" fill="#ff5ac4" />
      <circle cx="8" cy="20" r="2.5" fill="#579bfc" />
      <path
        fill="#323338"
        d="M7 22V8l4.5 7L16 8v14h-2.2v-8.2L11 20.5 9.2 14V22H7z"
      />
    </svg>
  );
}

function WorkizLogo() {
  return (
    <span className="workiz-logo" aria-hidden="true">
      WORKIZ
    </span>
  );
}

function IntegrationHub() {
  return (
    <div className="integration-hub" aria-hidden="true">
      <div className="integration-hub__glow" />
      <svg
        className="integration-hub__wave"
        viewBox="0 0 400 120"
        preserveAspectRatio="none"
      >
        <path
          d="M 8 32 C 80 72, 140 88, 200 52 S 320 22, 392 38"
          fill="none"
          stroke="#d8e4dc"
          strokeWidth="1.5"
        />
      </svg>
      <ul className="integration-hub__icons">
        <li
          className="integration-hub__item integration-hub__item--jobber"
          title="Jobber"
        >
          <span className="integration-hub__tile">
            <JobberLogo />
          </span>
        </li>
        <li
          className="integration-hub__item integration-hub__item--zapier"
          title="Zapier"
        >
          <span className="integration-hub__tile">
            <ZapierLogo />
          </span>
        </li>
        <li
          className="integration-hub__item integration-hub__item--center"
          title="Review Lumen"
        >
          <span className="integration-hub__tile integration-hub__tile--center">
            <BrandLogo variant="light" className="brand-logo--hub" />
          </span>
        </li>
        <li
          className="integration-hub__item integration-hub__item--monday"
          title="Monday.com"
        >
          <span className="integration-hub__tile">
            <MondayLogo />
          </span>
        </li>
        <li
          className="integration-hub__item integration-hub__item--workiz"
          title="Workiz"
        >
          <span className="integration-hub__tile">
            <WorkizLogo />
          </span>
        </li>
      </ul>
    </div>
  );
}


export function FeaturesSection() {
  return (
    <section className="features" aria-labelledby="features-heading">
      <div className="container">
        <header className="features__header">
          <h2 id="features-heading" className="features__title">
            Getting reviews has never been easier
          </h2>
          <p className="features__subtitle">
            Review Lumen does the hard work for you and with easy-to-use
            features, your reputation grows on auto pilot.
          </p>
        </header>

        <div className="features__grid">
          <article className="features-card features-card--large">
            <div className="features-card__head">
              <span className="features-card__badge">
                <FeatureBadgeIcon type="personalized" />
              </span>
              <h3 className="features-card__title">
                Personalized Review Requests
              </h3>
            </div>
            <p className="features-card__desc">
              Personalized images with your customers name to get their attention
              and increase your review conversion rate.
            </p>
            <div className="features-card__visual features-card__visual--photo">
              <img
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=800&q=80"
                alt=""
              />
              <div className="review-toast">
                <span className="review-toast__bell" aria-hidden="true">
                  <svg viewBox="0 0 20 20" width="18" height="18">
                    <path
                      fill="#122a93"
                      d="M10 2a6 6 0 00-4 10.5V16h8v-3.5A6 6 0 0010 2z"
                    />
                  </svg>
                </span>
                <span>Rick Wilson just left a 5 star review!</span>
              </div>
              <div className="personalized-name-tag">Rick!</div>
            </div>
          </article>

          <article className="features-card features-card--large features-card--integrations">
            <div className="features-card__head">
              <span className="features-card__badge">
                <FeatureBadgeIcon type="integrations" />
              </span>
              <h3 className="features-card__title">
                Seamlessly Integrates with Your Current Tools
              </h3>
            </div>
            <p className="features-card__desc">
              Our platform is compatible with your favorite CRMs and can
              integrate into a wide range of platforms. Connect once and never
              worry again!
            </p>
            <IntegrationHub />
          </article>
          
          <article className="features-card features-card--small">
            <div className="features-card__head">
              <span className="features-card__badge">
                <FeatureBadgeIcon type="ai" />
              </span>
              <h3 className="features-card__title">Review Lumen x Paige</h3>
            </div>
            <p className="features-card__desc">
            We keep your Google Business Profile active and optimized to improve your visibility and help you rank higher in local searches.
            </p>
          </article>
          
          <article className="features-card features-card--small">
            <div className="features-card__head">
              <span className="features-card__badge">
                <FeatureBadgeIcon type="ai" />
              </span>
              <h3 className="features-card__title">AI Review Responses</h3>
            </div>
            <p className="features-card__desc">
              We will take the burden of you, by responding to your positive
              reviews for you.
            </p>
          </article>

          <article className="features-card features-card--small">
            <div className="features-card__head">
              <span className="features-card__badge">
                <FeatureBadgeIcon type="followups" />
              </span>
              <h3 className="features-card__title">Easy Follow-ups</h3>
            </div>
            <p className="features-card__desc">
              If they haven&apos;t left a review we can send gentle reminders to
              get the reviews you deserve.
            </p>
          </article>

          <article className="features-card features-card--small">
            <div className="features-card__head">
              <span className="features-card__badge">
                <FeatureBadgeIcon type="reactivation" />
              </span>
              <h3 className="features-card__title">Review Reactivation</h3>
            </div>
            <p className="features-card__desc">
              Turn those happy customers that &quot;said&quot; they&apos;d leave a
              review into real reviews.
            </p>
          </article>
        </div>

        <div className="features__ctas">
          <a href="#pricing" className="btn btn--primary btn--lg">
            Start getting reviews
          </a>
          <a
            href={BOOK_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--secondary btn--lg features__cta-demo"
          >
            Book a demo
          </a>
        </div>
      </div>
    </section>
  );
}
